// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"c660e9c4","670":"ef37e140"}[chunkId] + ".chunk.js";
};